import React from 'react';

const CrownIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8772_4350)">
      <path
        d="M12 6.60001C12.3916 6.60001 12.7091 6.28253 12.7091 5.89091C12.7091 5.49929 12.3916 5.18182 12 5.18182C11.6084 5.18182 11.2909 5.49929 11.2909 5.89091C11.2909 6.28253 11.6084 6.60001 12 6.60001Z"
        fill="#F2C118"
      />
      <path
        d="M19.2909 8.63638C19.6825 8.63638 20 8.31891 20 7.92729C20 7.53567 19.6825 7.2182 19.2909 7.2182C18.8993 7.2182 18.5818 7.53567 18.5818 7.92729C18.5818 8.31891 18.8993 8.63638 19.2909 8.63638Z"
        fill="#F2C118"
      />
      <path
        d="M4.70909 8.63638C5.10071 8.63638 5.41818 8.31891 5.41818 7.92729C5.41818 7.53567 5.10071 7.2182 4.70909 7.2182C4.31747 7.2182 4 7.53567 4 7.92729C4 8.31891 4.31747 8.63638 4.70909 8.63638Z"
        fill="#F2C118"
      />
      <path
        d="M18 16.8182C18 16.6182 17.8364 16.4545 17.6364 16.4545H6.72728C6.52728 16.4545 6.36365 16.6182 6.36365 16.8182V18.4545C6.36365 18.6545 6.52728 18.8182 6.72728 18.8182H17.6364C17.8364 18.8182 18 18.6545 18 18.4545V16.8182Z"
        fill="#F2C118"
      />
      <path
        d="M4.47272 9.34545L6.07272 14.9818C6.14545 15.2 6.34545 15.3636 6.58181 15.3636H12H17.4182C17.6545 15.3636 17.8545 15.2182 17.9273 14.9818L19.5273 9.34545C19.5636 9.2 19.4364 9.07272 19.2909 9.12727L14.6727 10.7818C14.6 10.8182 14.5091 10.7818 14.4545 10.7091L12.1454 7.23636C12.0727 7.12727 11.9091 7.12727 11.8364 7.23636L9.52727 10.6909C9.47272 10.7636 9.38181 10.8 9.30909 10.7636L4.70909 9.12727C4.56363 9.07272 4.41818 9.2 4.47272 9.34545Z"
        fill="#F2C118"
      />
    </g>
  </svg>
);

export default CrownIcon;
